import { registerController } from "../registry";

registerController("calendar", (_el: HTMLElement) => {
  // Calendar interactivity will be added in later tracks
  // - View switching (month/week/day/list)
  // - Event click -> detail popup
  // - Keyboard navigation
});
